// @ts-nocheck
import { FC, forwardRef, useRef } from "react";
import { ToggleSwitchComponentProps } from "../../interface";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const ToggleSwitchComponent: FC<ToggleSwitchComponentProps> = forwardRef(
  (props: ToggleSwitchComponentProps, ref: any) => {
    const internalRef = useRef();
    const toggleSwitchRef = ref || internalRef;

    const SwitchComponent = styled((props) => (
      <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        checked={props.isChecked || props.checked}
        {...props}
      />
    ))(({ theme }) => ({
      width: 44,
      height: 20,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 4,
        transitionDuration: "500ms",
        "&.Mui-checked:hover .MuiSwitch-thumb": {
          background: "black !important",
        },

        "&.Mui-checked": {
          transform: "translateX(22px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            background: "linear-gradient(100.44deg, var(--gradient-color) 0%, var(--primary-gradient-color2) 110.4%)",
            opacity: 1,
            border: 0,
          },

          "&.Mui-disabled + .MuiSwitch-track": {
            background: " var(--Icon-icon-secondary, var(--text-light))",
          },

          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            color: "white !important",
            background: "white !important",
            width: 12,
            height: 12,
          },
        },
        "&:not(.Mui-checked):hover .MuiSwitch-thumb": {
          background:
            "linear-gradient(100.44deg, var(--gradient-color) 0%, var(--primary-gradient-color2) 110.4%) !important",
        },

        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          background: "#B3B4C1",
          color: "#B3B4C1",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
          // ...theme.applyStyles('dark', {
          //   opacity: 0.3,
          // }),
          border: "1px solid var(--text-light)",
        },
      },

      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        color: "black",
        width: 12,
        height: 12,
      },

      "& .MuiSwitch-track": {
        borderRadius: 21 / 2,
        backgroundColor: "white",
        opacity: 1,
        border: "1px solid var(--system-colour-47)",
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    }));

    return (
      <div className="flex items-center gap-1">
        <FormGroup>
          <FormControlLabel
            sx={{ marginInlineStart: 0 }}
            control={
              <SwitchComponent
                {...props}
                onChange={props.onChange || props.change}
                inputRef={toggleSwitchRef}
                sx={{ m: 1 }}
                disabled={props.isDisabled || props.disabled}
              />
            }
            label={props.label}
            labelPlacement={props.labelPlacement || "start"}
          />
        </FormGroup>
      </div>
    );
  },
);
ToggleSwitchComponent.displayName = "ToggleSwitchComponent";
export default ToggleSwitchComponent;
